// extracted by mini-css-extract-plugin
export var moreTopics = "moreTopics-module--moreTopics--ALzAW";